<template>
    <div class="ws-login-wrapper">
    <!-- loading -->
    <div  v-if="isLoading"  class="loading-wrapper row-center" >
      <md-activity-indicator type="roller" color="#1b6fdc" vertical>
       <span  style="color:#1b6fdc !important;" >{{ $t('common.mixinWsLoading') }}</span> 
      </md-activity-indicator>
    </div>
      <div v-if="error" class="error-message">
        {{ error }}
      </div>

    </div>
  </template>
  
<script>
import {
  ActivityIndicator,
  Dialog,
  Toast,
} from 'mand-mobile';
import MixinAuth from '@/utils/mixin-auth';
import { mapState } from 'vuex';
// import VConsole from 'vconsole';
// new VConsole(); 调试 测试用


export default {
  name: 'WsLogin',

  components: {
    [ActivityIndicator.name]: ActivityIndicator,
    [Dialog.name]: Dialog,
  },

  data() {
    return {
      isLoading: false,
      error: '',
      mixinAuth: null,
      modalVisible: false, // 控制模态框显示状态
      codeId: '', // 存储 Mixin 授权码ID
    };
  },

  computed: {
    ...mapState({
      settings: state => state.settings,
    }),
    webNum() {
      return this.settings.hostData.webNum;
    },
    clientId() {
      // return '52e7cfab-e34d-4557-a5f7-db76551be0de'; //7000104225
      return this.settings.hostData.clientId;  //防止失误
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  },

  created() {
    // 如果已登录，重定向到首页
    if (this.isLogin) {
      this.$router.replace('/exchage');
      return;
    }
    let promise = Promise.resolve();
    if (!this.settings.isSettingsLoaded) {
      Toast.loading(this.$t('common.loading'));
      promise = this.$store.dispatch('updateSettings'); //确保获取到当前网站的webNum
    }
    promise
      .then(() => {
        Toast.hide();
        this.startMixinAuth();
      })
      .catch(err => {
        Toast.hide();
        Toast.failed(`${this.$t('error.occur')}${err.message}`);
      });
  },

  methods: {
    startMixinAuth() {
      this.isLoading = true;
      this.error = '';
    
      // 创建 MixinAuth 实例
      this.mixinAuth = new MixinAuth({
        useModal: true, // 开启模态框模式
      });
    
      // 定义授权范围
      const scope = 'PROFILE:READ ASSETS:READ PHONE:READ SNAPSHOTS:READ';
    
      // 开始授权流程
      this.mixinAuth.authorize(
        this.clientId,
        scope,
        this.handleAuthSuccess,
        this.handleAuthError,
        this.showAuthModal, // 显示模态框回调
      );
    },

    // // 显示授权模态框
    // showAuthModal(codeId) {
    //   this.codeId = codeId; // 保存授权码ID
    //   this.modalVisible = true; // 显示模态框
    // },
    showAuthModal(codeId) {
      Dialog.confirm({
        title: this.$t('common.plsAuthorizeMixin'),
        content: `mixin://codes/${codeId}`,
        cancelText: this.$t('common.cancel'),
        confirmText: this.$t('common.confirm'),
        onConfirm: () => {
          window.location.href = `mixin://codes/${codeId}`;
        },
      });
    },
    
    // 处理授权成功
    handleAuthSuccess(authCode) {
      // 调用后端 API 处理授权码 这里是web 页面
    //   alert(authCode);
      this.modalVisible = false; // 隐藏模态框
      window.location.replace('/auth?code='+authCode+'&return_to='+this.webNum); //传回后端web/auth页面
     
    },
    
    // 处理授权错误
    handleAuthError(error) {
      this.isLoading = false;
      this.error = `${this.$t('error.occur') || '发生错误：'}${error.description || error.message}`;
      // eslint-disable-next-line no-console
      console.error(error);
    },
  },

  beforeDestroy() {
    // 在组件销毁前断开 WebSocket 连接
    if (this.mixinAuth) {
      this.mixinAuth.disconnect();
    }
  },
};
</script>
  
<style scoped>
  .ws-login-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 80vh;
  }
  
  .loading-message, .error-message {
    text-align: center;
    padding: 20px;
    margin: 20px;
  }
  
  .error-message {
    color: red;
    border: 1px solid red;
    border-radius: 4px;
  }
  .loading-wrapper {
    min-height: 80vw;
  }
</style>